module.exports = __webpack_public_path__ + "static/media/Sidebar-premium-icon-inactive.1cf12a14.svg";